import IssueTile from './IssueTile';

export default IssueTile;
